var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.taskLogs.length == 0)?_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"h2 mt-3"},[_vm._v("No logs to show")])]):_c('div',_vm._l((_vm.taskLogs),function(taskLog,key){return _c('TaskLogsListCard',{key:key,attrs:{"taskLog":taskLog}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }